import { Navigate } from 'react-router-dom';
import { ReactSession } from '../utils/ReactSession.jsx';
import { AES, enc } from 'crypto-js';
import SessionReload from './component-assets/SessionReload.jsx';
import { iAmHigherAuthority } from '../libs.jsx';
import BillingPage from '../pages/billing/BillingPage.jsx';

/**
 * Billing dispatcher — gates access by role_weight > 10 and renders the
 * V2 BillingPage. No V1 equivalent exists for this page.
 */
const Billing = () => {
  let dData;
  if (ReactSession.get('PAL') != null) {
    const bData = AES.decrypt(ReactSession.get('PAL'), import.meta.env.VITE_ESECRET);
    dData = JSON.parse(bData.toString(enc.Utf8));
  }

  return iAmHigherAuthority(10, dData?.role_weight) ? (
    <>
      {dData?.migrated ? <SessionReload /> : null}
      <BillingPage />
    </>
  ) : <Navigate to="/" />;
};

export default Billing;
